module.exports = __webpack_public_path__ + "media/jackpot1.8f132ef5.webm";